import React, { useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import about from '../../assets/images//Layer-16.png';
import about1 from '../../assets/images/our-mission.jpg';
import about2 from '../../assets/images/Layer-17.jpg';
import ContentController from '../../apis/controller/content.controller';
import { renderImage } from '../../Components/helper/image';


function AboutPage() {
	const [aboutus, setAboutus] = useState();
	const [loader, setLoader] = useState(false);
	useEffect(() => {
		getAboutus();
		window.scrollTo(0, 0);
	}, []);

	const getAboutus = async () => {
		setLoader(true);
		let res = await new ContentController().aboutUs();
		if (res && res.status) {
			setAboutus(res);
		}
		setLoader(false);
	};
	return (
		<>
			{aboutus && aboutus.breadcrumb ? <PageTitle title={aboutus.breadcrumb.main_title} image={aboutus.breadcrumb.image} /> : null}
			{aboutus && <section className="about-us-wrap">
				<div className="container">
					<div className="row">
						{aboutus && aboutus.page ? <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="our-story-wrap text-center">
								<div className="content">
									<h3>
										{aboutus.page.title}
									</h3>
									{/* <p>
									Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
									</p> */}
								</div>
								<div className="group-img">
									<img src={renderImage(aboutus.page.image, 'large')} alt="" />
								</div>
								<div className="img-content">
									<p>
										{aboutus.page.description}
									</p>
								</div>
							</div>
						</div> : null}
						{aboutus && aboutus.our_mission ? <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="our-mission-set">
								<div className="row align-items-center">
									<div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
										<div className="our-mission-wrap">
											<div className="our-mission-img">
												<img src={renderImage(aboutus.our_mission.image, 'medium')} alt="" />
											</div>
										</div>
									</div>
									<div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
										<div className="content vision">
											<h3>
												{aboutus.our_mission.title}
											</h3>
											<p>
												{aboutus.our_mission.description}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div> : null}
						{aboutus && aboutus.our_vision && <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
							<div className="our-mission-set">
								<div className="row align-items-center">
									<div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 order-sm-0 order-2">
										<div className="content vision-2 text-end">
											<h3>
												{aboutus.our_vision.title}
											</h3>
											<p>
												{aboutus.our_vision.description}
											</p>
										</div>
									</div>
									<div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
										<div className="our-mission-wrap">
											<div className="our-mission-img">
												<img src={renderImage(aboutus.our_vision.image, 'large')} alt="" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>}
					</div>
				</div>
			</section>}
		</>
	);
}

export default AboutPage;
